import { useEffect, useState } from 'react'
import { AuthContext } from '../contexts/AuthContext'
import { CDPClient } from 'shared-code/cdp-lib/library'
import { logWarning } from 'shared-code/log'
import { CDPRuntimeEvent } from 'shared-code/cdp-lib/cdp-types'

interface UseGlobalCdpClientOptions {
  eventsCollectorUrl?: string
}

const CDP_CLIENT_INITIALIZED = 'cdp-client-initialized'

export function useGlobalCdpClient(opts: UseGlobalCdpClientOptions): void {
  const { authState } = AuthContext.useContainer()
  useEffect(() => {
    if (opts.eventsCollectorUrl === undefined) {
      logWarning('CDP Event Client: eventsCollectorUrl is undefined')
      return
    }

    if (authState?.profile) {
      window.cdpClient = new CDPClient({
        userId: authState.profile.sub,
        eventsCollectorUrl: opts.eventsCollectorUrl,
      })
    } else {
      window.cdpClient = new CDPClient({
        userId: null,
        eventsCollectorUrl: opts.eventsCollectorUrl,
      })
    }

    window.dispatchEvent(new CustomEvent(CDP_CLIENT_INITIALIZED))
  }, [authState])
}

export function useCdpClient<T extends CDPRuntimeEvent>(): CDPClient<T> | null {
  const [client, setClient] = useState<CDPClient<T> | null>(null)

  useEffect(() => {
    const eventHandler = (): void => {
      setClient(window.cdpClient)
    }

    setClient(window.cdpClient)

    window.addEventListener(CDP_CLIENT_INITIALIZED, eventHandler)
    return () => {
      window.removeEventListener(CDP_CLIENT_INITIALIZED, eventHandler)
    }
  }, [])

  return client
}
